import { useState } from 'react'
import { axiosInstance } from '../helpers'

export interface VendorW9UploadInfo {
    vendor_name: string
    vendor_id: number
    apartment_name: string
    apartment_id: number
    apartment_names?: string[]
    expires_at: string
    already_uploaded: boolean
}

export interface VendorW9UploadResponse {
    success: boolean
    message: string
    vendor_w9_id: number
}

export const useVendorW9Upload = (token: string | null) => {
    const [info, setInfo] = useState<VendorW9UploadInfo | null>(null)
    const [isLoadingInfo, setIsLoadingInfo] = useState(false)
    const [infoError, setInfoError] = useState<string | null>(null)
    const [isUploading, setIsUploading] = useState(false)
    const [
        uploadResult,
        setUploadResult,
    ] = useState<VendorW9UploadResponse | null>(null)
    const [uploadError, setUploadError] = useState<string | null>(null)

    const fetchInfo = async () => {
        if (!token) return
        setIsLoadingInfo(true)
        setInfoError(null)
        try {
            const res = await axiosInstance.get<VendorW9UploadInfo>(
                `/company/vendor-w9-upload/?token=${token}`,
            )
            setInfo(res.data)
        } catch (err: any) {
            setInfoError(
                err?.response?.data?.error || 'Invalid or expired link',
            )
        } finally {
            setIsLoadingInfo(false)
        }
    }

    const upload = async (file: File, name?: string) => {
        if (!token) return
        setIsUploading(true)
        setUploadError(null)
        try {
            const formData = new FormData()
            formData.append('token', token)
            formData.append('file', file)
            if (name) formData.append('name', name)
            const res = await axiosInstance.post<VendorW9UploadResponse>(
                '/company/vendor-w9-upload/',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } },
            )
            setUploadResult(res.data)
        } catch (err: any) {
            setUploadError(err?.response?.data?.error || 'Upload failed')
        } finally {
            setIsUploading(false)
        }
    }

    return {
        info,
        isLoadingInfo,
        infoError,
        fetchInfo,
        upload,
        isUploading,
        uploadResult,
        uploadError,
    }
}
